<script setup>
import { ref, computed, onMounted } from 'vue'
import { CustomerService } from '@/services/customer-service'
import { Log } from '@/modules/util/log'
import { debounce } from '@/modules/util/debounce'

const customerService = new CustomerService
const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])

const vendors = ref([])
const selected = ref(null)
const search = ref('')

const displayVendors = computed(() => {
	return [
		...vendors.value.filter(v => v.customer_id !== props.modelValue),
		selected.value ? selected.value : undefined,
	]
})

const onSearch = (val) => {
	search.value = val
	listVendors(val)
}

const getVendor = async (id) => {
	if (vendors.value.find(v => v.customer_id === id)) {
		selected.value = vendors.value.find(v => v.customer_id === id)
		return
	}

	try {
		const { status, results } = (await customerService.get(id)).body

		if (!status) {
			throw new Error(JSON.stringify(results))
		}

		selected.value = results[0]
	} catch (err) {
		console.error('getVendor:', err.message)
		Log.warning('Could not fetch vendor details.')
	}
}

const listVendors = debounce(async (q) => {
	try {
		const { status, results } = (await customerService.list({ q })).body

		if (!status) {
			throw new Error(JSON.stringify(results))
		}

		vendors.value = results
	} catch (err) {
		console.error('listVendors:', err.message)
		Log.error('Could not refresh vendors.')
	}
}, 150)

const onUpdate = (val) => {
	emit('update:modelValue', val)
	getVendor(val)
}

onMounted(() => {
	if (props.modelValue) {
		getVendor(props.modelValue)
	}
})
</script>

<template>
<v-autocomplete
	:model-value="modelValue"
	:label="field.label"
	:items="displayVendors"
	:search="search"
	item-title="customer_name"
	item-value="customer_id"
	no-data-text="Search for a customer"
	hide-details="auto"
	@update:search="onSearch"
	@update:model-value="onUpdate"
/>
</template>

<style lang="scss" scoped>

</style>